import React from 'react';
import CategoryLandingPage from './CategoryLandingPage';
import { halloweenConfig } from '../configs/categoryLandings';

export default function HalloweenLandingPage() {
  return <CategoryLandingPage config={halloweenConfig} />;
}
